// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3xkMU","item":"PaymentsMobile_item__3Je-v","label":"PaymentsMobile_label__2QzSG","amount":"PaymentsMobile_amount__2mtVw"};